function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  "aria-hidden": "true",
  viewBox: "0 0 29 29",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.3 23.4A12.2 12.2 0 011 10a12.2 12.2 0 1122.7 8.5l4 4a3.3 3.3 0 01-4.7 4.7l-3.8-3.8zm0-9a6.5 6.5 0 11-12.7-3 6.5 6.5 0 0112.7 3z",
  fill: "#370E7B"
}));